import "slick-carousel";
import { resizeBackgroundImages } from "../../js/utilities/responsive-images";

/**
 * Initialize addon slider
 *
 * @return {Void}
 */
$(".js-slider-addon").each(function () {
  const $this = $(this);
  const $arrowPrev = $this.find(".js-slider-prev");
  const $arrowNext = $this.find(".js-slider-next");

  $this.find(".js-slider-addon-slides").slick({
    dots: false,
    arrows: true,
    prevArrow: $arrowPrev,
    nextArrow: $arrowNext,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
  });
  $this.on("afterChange", function () {
    const targetImages = document.querySelectorAll(
      ".js-responsive-background-image"
    );
    resizeBackgroundImages(targetImages);
  });
});
